import { useAuthorizeUser } from "@coworker/apprestructured/src/shared/hooks/useAuthorizeUser";
import { SimpleDefaultLoadingScreen } from "@coworker/apprestructured/src/shared/simple/SimpleLoading/SimpleDefaultLoadingScreen";
import { Error } from "@coworker/apprestructured/src/login/components/Error/Error";
import { ErrorType } from "@coworker/apprestructured/src/shared/constants/errorTypes";
import { ReactElement } from "react";
import { NewUserPage } from "@coworker/apprestructured/src/login/components/NewUserPage/NewUserPage";
import { UnauthorizedPage } from "@coworker/apprestructured/src/login/components/Unauthorized/UnauthorizedPage";
import { useUserHasFixaBasicPermissions } from "@coworker/apprestructured/src/login/hooks/useUserHasRoleOnPlatformOwner";
import useFlag, { FLAGS } from "@coworker/app/src/hooks/useFlag";

export const AuthorizedUserRoute = ({
  children,
}: {
  children: ReactElement;
}) => {
  const userState = useAuthorizeUser();
  const {
    data: hasFixaBasicPermissions,
    isLoading: isFixaBasicPermissionsLoading,
  } = useUserHasFixaBasicPermissions();

  // TO-DO: COAPP-12897 - remove the feature flag once deployed to all markets.
  const enableAtkomstUnauthorizedPage = useFlag(
    FLAGS.ENABLE_ATKOMST_UNAUTHORIZED_PAGE
  );

  if (userState.isLoading || isFixaBasicPermissionsLoading) {
    return <SimpleDefaultLoadingScreen />;
  }

  if (enableAtkomstUnauthorizedPage && !hasFixaBasicPermissions) {
    return <UnauthorizedPage />;
  }

  // Redirect to NewUserPage for users that are not fully provisioned yet
  if (userState.errorType === ErrorType.NOTFOUND) {
    return <NewUserPage />;
  }

  if (userState.isError) {
    return (
      <Error isAccessIssue={userState.errorType === ErrorType.FORBIDDEN} />
    );
  }

  return userState?.isActive ? children : <Error isAccessIssue={false} />;
};
